import React from "react";

/**
 * Y-monogram badge — used as a brand-foiled separator in marquee strips
 * and inline accents. Pink→teal gradient circle with a bold white "Y"
 * inside (Cabinet Grotesk Black).
 */
export default function YMonogram({ size = 28, className = "", id = "ym" }) {
  const gid = `ym-grad-${id}`;
  return (
    <span
      className={`inline-flex items-center justify-center align-middle ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 32 32" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF6B9D" />
            <stop offset="55%" stopColor="#EE4F7A" />
            <stop offset="100%" stopColor="#55D9C2" />
          </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="15" fill={`url(#${gid})`} />
        <text
          x="16"
          y="22"
          textAnchor="middle"
          fontFamily='"Cabinet Grotesk", "Space Grotesk", system-ui, sans-serif'
          fontWeight="900"
          fontSize="20"
          fill="#FFF9F4"
        >
          Y
        </text>
      </svg>
    </span>
  );
}
